import React, { useState, useEffect } from 'react';
import { Share, X, PlusSquare } from 'lucide-react';

export const IosInstallPrompt: React.FC = () => {
  const [showPrompt, setShowPrompt] = useState(false);

  useEffect(() => {
    // Check if device is iOS Safari and not running in standalone PWA mode
    const isIos = /iPhone|iPad|iPod/.test(window.navigator.userAgent);
    const isStandalone = ('standalone' in window.navigator) && (window.navigator as any).standalone;
    const isDismissed = localStorage.getItem('ios_pwa_prompt_dismissed');

    if (isIos && !isStandalone && !isDismissed) {
      setShowPrompt(true);
    }
  }, []);

  const handleDismiss = () => {
    setShowPrompt(false);
    localStorage.setItem('ios_pwa_prompt_dismissed', 'true');
  };

  if (!showPrompt) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 z-50 max-w-md mx-auto bg-white/95 backdrop-blur-md border border-[#e4e3df] shadow-lg rounded-2xl p-4 text-[#242729] animate-in fade-in slide-in-from-bottom-4 duration-300">
      <div className="flex items-start justify-between gap-3">
        <div className="w-10 h-10 rounded-xl bg-[#fff0eb] border border-[#fbd4c6] flex items-center justify-center shrink-0">
          <img src="/apple-touch-icon.png" alt="Gistly Icon" className="w-8 h-8 rounded-lg shadow-xs" />
        </div>

        <div className="flex-1 text-sm">
          <div className="font-semibold text-[#242729] text-base mb-1">
            ติดตั้งบน iPhone หน้าจอโฮม
          </div>
          <p className="text-[#60676b] text-xs leading-relaxed">
            อ่านบทสรุปความรู้แบบเต็มจอ ใช้งานง่ายเหมือน Native App
          </p>

          <div className="mt-3 flex items-center gap-2 text-xs bg-[#f8f8f6] p-2.5 rounded-xl border border-[#e4e3df] text-[#242729]">
            <span>1. กดปุ่มแชร์</span>
            <Share className="w-4 h-4 text-[#e56f51] shrink-0" />
            <span>2. เลือก</span>
            <span className="font-medium flex items-center gap-1 text-[#242729]">
              <PlusSquare className="w-3.5 h-3.5 text-[#60676b]" /> เพิ่มไปยังหน้าจอโฮม
            </span>
          </div>
        </div>

        <button
          onClick={handleDismiss}
          className="p-1 rounded-full text-[#8b9194] hover:text-[#242729] hover:bg-[#f5f4f1] transition-colors"
          aria-label="ปิด"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};
